import { Container } from "@material-ui/core";

import { Generator } from "../../../../components/Generator";
import { Grid } from "../../../../components/Grid";
import { Heading } from "../../../../components/Heading";
import { Sidebar } from "../../../../components/Navigation/Sidebar";
import { FormType } from "../../../../components/enums";
import {
  usePreventRefresh,
  useScrollDocument,
  useShouldRedirectToHomepage,
} from "../../../../hooks";
import { Url } from "../../../../router/enums";
import { selectIsFormValidated } from "../../../../store/HOC/genericUI.selectors";
import { selectUIData } from "../VehicleOwner/vehicleOwner.selectors";

import styles from "./Damages.module.scss";
import { additionalDataForm, imagesDescriptionDataForm } from "./form";

export const Damages = (): JSX.Element => {
  useShouldRedirectToHomepage(selectIsFormValidated(selectUIData));
  useScrollDocument();
  usePreventRefresh();

  return (
    <Container className={styles.container}>
      <Heading component="h1" variant="h1" spacingBottom={4}>
        Zgłoś szkodę z OC sprawcy
      </Heading>
      <Grid
        container
        alignItems="flex-start"
        className={styles.page}
        spacingInnerLeft={{ xs: 5, sm: 10 }}
        spacingInnerRight={{ xs: 5, sm: 10 }}
        direction="row"
      >
        <Sidebar
          currentRoute={Url.OC_VEHICLE_DAMAGES}
          type={FormType.OC_VEHICLE}
        />
        <Generator
          form={[imagesDescriptionDataForm, additionalDataForm]}
          render={(generatedForm) => (
            <Grid item xs={12} md={8}>
              {generatedForm}
            </Grid>
          )}
        />
      </Grid>
    </Container>
  );
};
